import React, { useEffect, useState } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { useApplicationCommon } from "../../utils/ApplicationCommon";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const GNBPURE06004S = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const emptNo = params.get("empt_no");                   // URL에서 empt_no 파라미터를 가져옴

  const { doAction } = useApplicationCommon();            // ✅ `doAction`만 사용
  const [isDepthOpen, setIsDepthOpen] = useState(false);  // depth2 메뉴 열림 상태
  const [empDetail, setEmpDetail] = useState([]);         // 채용공고 상세 조회

  // ✅ 최초 조회
  useEffect(() => {
    
    if (emptNo) {
      goSearch(emptNo);
    }
  }, []);

  // 구분 값 변환
const getEmptDvCdText = (code) => {
  switch (code) {
    case "1": return "경력무관";
    case "2": return "프리랜서";
    default: return "기타";
  }
};

// 학력 값 변환
const getAcdcLvelVlText = (code) => {
  switch (code) {
    case "1": return "학력무관";
    case "2": return "고졸이상";
    case "3": return "초대졸이상";
    case "4": return "대졸이상";
    default: return "기타";
  }
};

  // ✅ 채용공고 상세 조회
  const goSearch = (emptNo) => {
    const actionForm = {
      txGbnCd: "recruitDetail",
      empt_no: emptNo
    };

    doAction("COM0004SC", actionForm, (resData) => {
      if (resData.APP_HEADER.respCd === "N00001") {
        setEmpDetail(resData);
      }
    });
  };
    
  return (
    <CommonLayout>
      <CommonMenu />

      <div id="contents" className="container">

        <div className="sub-title bg-type06">
          <h2>인재 채용</h2>
        </div>

        <div className="location_wrap"
          onClick={() => setIsDepthOpen(!isDepthOpen)}>
          <ul className="depth1">
            <li><Link to="/">home</Link></li>
            <li><Link to="/" onClick={(e) => e.preventDefault()}>채용공고<span></span></Link>
              <ul className="depth2" style={{ display: isDepthOpen ? "block" : "none" }}>
                <li><Link to="/GNBPURE06001S">인재상</Link></li>
                <li><Link to="/GNBPURE06002S">복리후생</Link></li>
                <li><Link to="/GNBPURE06003S">채용공고</Link></li>
              </ul>
            </li>
          </ul>
        </div>
        <div id="cont" className="cont">
          <div className="inner">
            <h3>채용공고</h3>

            {empDetail ? (
              <dl className="recruit-wrap recruit-view">
                <dt>
                  <p>{empDetail.empt_ttl}</p>
                  <span>
                      {empDetail.empt_str_dt && empDetail.empt_end_dt ? (
                        <>
                          {empDetail.empt_str_dt.substring(0, 4)}-{empDetail.empt_str_dt.substring(4, 6)}-{empDetail.empt_str_dt.substring(6, 8)}
                          ~
                          {empDetail.empt_end_dt.substring(0, 4)}-{empDetail.empt_end_dt.substring(4, 6)}-{empDetail.empt_end_dt.substring(6, 8)}
                        </>
                      ) : (
                        "채용일자 정보가 없습니다."
                      )}
                    </span>
                </dt>

                <dd>
                  <div>
                    <strong className="mobile">구분</strong>
                    {getEmptDvCdText(empDetail.empt_dv_cd)}
                  </div>
                  <div>
                    <strong className="mobile">학력</strong>
                    {getAcdcLvelVlText(empDetail.acdc_lvel_vl)}
                  </div>
                  <div>
                    <strong className="mobile">근무지</strong>
                    {empDetail.wkpl_vl}
                  </div>
                  <div>
                    <strong className="mobile">인원</strong>
                    {empDetail.empt_cnt}명
                  </div>
                  <div>
                    <strong>상세내용</strong>
                    <pre>{empDetail.empt_detl_cntn}</pre>
                  </div>
                  <div>
                    <strong>전형절차</strong>
                    <div className="process-flow">
                      <div className="step">
                        <img src="/asset/img/recruit/icon_document.png" alt="서류전형"/>
                        <span>1. 서류전형</span>
                      </div>
                      <img src="/asset/img/recruit/icon_arrow.png" alt="화살표" className="arrow"/>
                      <div className="step">
                        <img src="/asset/img/recruit/icon_interview.png" alt="임원면접"/>
                        <span>2. 임원면접</span>
                      </div>
                      <img src="/asset/img/recruit/icon_arrow.png" alt="화살표" className="arrow"/>
                      <div className="step">
                        <img src="/asset/img/recruit/icon_handshake.png" alt="최종합격"/>
                        <span>3. 최종합격</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <strong>제출방법</strong>
                    ▣ 서류 전형 : 지원자는 자유이력서(희망연봉 기재)/자기소개서(경력자는 경력기술서 포함)/포트폴리오를 인사지원팀 이메일(cha@gnbsoftec.co.kr)로 보내주세요.
                  </div>
                  <div>
                    <strong>기타사항</strong>
                    ▣ 제출한 입사지원 서류는 반환하지 않으며, 입사지원 검토용으로만 사용됩니다.<br />
                    ▣ 면접일정은 추후 통보됩니다.<br />
                    ▣ 입사지원 관련 구비서류는 최종합격자에 한하여 제출하게 됩니다.<br />
                    ▣ 지원서의 내용이 사실과 다르거나, 문서증빙이 불가능할 경우 채용이 취소될 수 있습니다.
                  </div>
                </dd>
              </dl>
            ) : (
              <div className="empDetail-None">
                <p>함께할 새로운 인재를 기다립니다. 다음 채용공고를 기대해 주세요!</p>
              </div>
            )}

            <ul className="btn-wrap">
              <li className="btn btn-primary"><Link to="/GNBPURE06003S">목록</Link></li>
            </ul>

          </div>
        </div>
      </div>
      <CommonFooter />
    </CommonLayout>
  );
};

export default GNBPURE06004S;